<template>
  <div>
    <div>
      <div class="bg-white padding">
        <div class="input-item flex" style="justify-content: space-between">
          <div style="display: flex; align-items: center">
            <div class="line"></div>
            <span class="text-nowrap">請輸入條碼</span>
          </div>
          <div class="icon-scan" @click="openScanner">掃描</div>
        </div>
        <div class="form">
          <div>
            <div class="field">
              <span class="required">*</span>
              第一段條碼
            </div>
            <input
              type="text"
              name="id_card_number"
              :placeholder="`${verify.barcode1.placeholder}`"
              class="input vinput"
              :maxlength="verify.barcode1.maxLength"
              v-model.trim="form.barcode1"
              @blur="verifyForm('barcode1')"
              @input="verifyInput('barcode1')"
              :class="verify.barcode1.status ? '' : 'error'"
            />
            <div class="required">{{ verify.barcode1.text }}</div>
          </div>
          <div>
            <div class="field">
              <span class="required">*</span>
              第二段條碼
            </div>
            <input
              type="text"
              name="id_card_number"
              :placeholder="`${verify.barcode2.placeholder}`"
              class="input vinput"
              :minlength="verify.barcode2.minLength"
              :maxlength="verify.barcode2.maxLength"
              v-model="form.barcode2"
              @blur="verifyForm('barcode2')"
              @input="verifyInput('barcode2')"
              :class="verify.barcode2.status ? '' : 'error'"
            />
            <div class="required">{{ verify.barcode2.text }}</div>
          </div>
          <div>
            <div class="field">
              <span class="required">*</span>
              第三段條碼
            </div>
            <input
              type="text"
              name="id_card_number"
              :placeholder="`${verify.barcode3.placeholder}`"
              class="input vinput"
              :minlength="verify.barcode3.minLength"
              :maxlength="verify.barcode3.maxLength"
              v-model.trim="form.barcode3"
              @blur="verifyForm('barcode3')"
              @input="verifyInput('barcode3')"
              :class="verify.barcode3.status ? '' : 'error'"
            />
            <div class="required">{{ verify.barcode3.text }}</div>
          </div>
        </div>
        <button class="btn btn-primary" :disabled="search_btn_disable" ref="search_btn" @click="getPaymentInformation(false)">查詢帳單</button>
        <div class="hint" @click="showSupportSchools()"><span>不確定哪些學校可以繳？</span><img src="../../assets/images/infoButton.png" style="width: 24px; height: 24px;"></div>
      </div>
      <div class="padding description">
        <ul class="text-gray2">
          <li>請尋找您手上費用帳單的超商專用「三段式條碼」進行掃描。</li>
          <li>學雜費代收服務，由台灣票據交換所及合作銀行(台北富邦銀行 &臺灣銀行 )提供。</li>
          <li>可使用悠遊付錢包、銀行帳戶連結、信用卡(<span class="text-blue">限台新銀行、玉山銀行發卡</span>)進行繳費扣款。</li>
          <li>若需繳費證明，請至【臺灣銀行-學雜費入口網】 或 【學校之校務系統】列印繳費收據。</li>
          <li>如須辦理退費，請向各級學校申請人工退費。</li>
        </ul>
      </div>
    </div>
    <transition>
      <section v-show="supportSchoolModal.show">
        <div class="bottom-dialog" :class="supportSchoolModal.show ? 'up' : 'down'">
          <div class="title-wrap">
            <div class="title">學校清單</div>
            <div class="icon-cancel" @click="closeSupportSchools"></div>
          </div>
          <div class="search-bar">
              <img src="../../assets/images/tuitionFee/barsSearchBarResourcesSearchGlyph.png" style="width: 14px; height: 14px; margin-right: 8px;">
              <input placeholder="請輸入校名" v-model="supportSchoolModal.filterKeyword" @input="filter()" />
              <img src="../../assets/images/tuitionFee/clear.png" style="width: 14px; height: 14px; " v-show="supportSchoolModal.filterKeyword !== ''" @click="clearFilter()">
          </div>
          
          <div ref="bottomDialogContent" class="bottom-dialog-content" :class="supportSchoolModal.show ? 'dialog-navbar' : ''">
            <div v-if="supportSchoolModal.filteredSupportSchools.length===0" class="empty">查無資料</div>
            <div @click="schoolClicked(school)" v-for="(school, i) in supportSchoolModal.filteredSupportSchools" :key="i">
              <div class="block">
                <div class="item-title" v-if="school.is_city">
                  <div class="text-gray2">{{ school.city_name }}</div>
                </div>
                <div class="item" v-if="!school.is_city">
                  <div class="text-gray2">{{ school.school_name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mask"></div>
      </section>
    </transition>
  </div>
</template>
<script>
import { queryBillList, getTuitionFeeSupportSchools } from '../../api/api';

export default {
  name: 'other-school-fee',
  components: {
  },
  data() {
    return {
      openScan: true,
      form: {
        barcode1: '',
        barcode2: '',
        barcode3: '',
      },
      verify: {
        barcode1: {
          status: true,
          text: '',
          placeholder: '共 9 碼',
          verifyRegex: '^([0-9]{6}[0-9a-zA-Z]{3})$',
          verifyErrorText: '前6碼需為數字，後3碼限數字及英文'
        },
        barcode2: {
          status: true,
          text: '',
          placeholder: '共 14 ~ 20 碼',
          verifyRegex: '^([0-9a-zA-Z]{16,20}|[0-9a-zA-Z]{14})$',
          verifyErrorText: '需為 14 ~ 20 碼'
        },
        barcode3: {
          status: true,
          text: '',
          placeholder: '共 10 或 15 碼',
          verifyRegex: '^([a-zA-Z0-9]{10}|[0-9a-zA-Z]{15})$',
          verifyErrorText: '需為 10 ~ 15 碼'
        },
      },
      verifyInputRule: {
        barcode1: false,
        barcode2: false,
        barcode3: false,
      },
      supportSchoolModal: {
        filterKeyword: '',
        show: false,
        supportSchools: [],
        filteredSupportSchools: [],
      }
    };
  },
  created() {
    window.getScanningResult = this.getScanningResult;
  },
  computed: {
    search_btn_disable() {
      return !Object.values(this.verifyInputRule).every((i) => i === true);
    },
  },
  methods: {
    clearFilter() {
      this.supportSchoolModal.filterKeyword = '';
      this.filter();
    },
    filter() {
      if (this.supportSchoolModal.filterKeyword === '') {
        this.generateFilterSchools(this.supportSchoolModal.supportSchools);
      } else {
        var list = [];
        this.supportSchoolModal.supportSchools.forEach((item, i) => {
          if (item.school_name.indexOf(this.supportSchoolModal.filterKeyword) !== -1) {
            item.is_city = false;
            list.push(item);
          }
        });
        this.generateFilterSchools(list);
      }
    },
    generateFilterSchools(list) {
      this.supportSchoolModal.filteredSupportSchools = [];
      var lastCity = null;
      list.forEach((item, i) => {
        if (item.city_name !== lastCity) {
            let city = Object.create(item);
            city.is_city = true;
            this.supportSchoolModal.filteredSupportSchools.push(city);  
        } 
        item.is_city = false;
        this.supportSchoolModal.filteredSupportSchools.push(item);
        lastCity = item.city_name;
      });
    },
    schoolClicked(school) {
      //alert(school.school_name);
    },
    closeSupportSchools() {
      this.supportSchoolModal.show = false;
    },
    showSupportSchools() {
      getTuitionFeeSupportSchools().then((res) => {
        if (res.error === undefined) {
          this.supportSchoolModal.supportSchools = res.school_list;
          this.filter();
          this.supportSchoolModal.show = true;
        }
      });
    },
    verifyForm(fieldName) {
      if (!this.verifyInput(fieldName)) {
        this.verify[fieldName].status = false;
        this.verify[fieldName].text = this.verify[fieldName].verifyErrorText;
        return false;
      } else {
        this.verify[fieldName].status = true;
        this.verify[fieldName].text = '';
        return true;
      }
    },
    verifyInput(fieldName) {
      const regexp = RegExp(/[\d|a-zA-Z|\\+|\\=|\\.|\-|\\$|\\|\s]+$/);
      let result = regexp.test(this.form[fieldName]);
      this.form[fieldName] = this.form[fieldName].toUpperCase();

      if (result) {
        if (new RegExp(this.verify[fieldName].verifyRegex).test(this.form[fieldName])) {
          this.verifyInputRule[fieldName] = true;
        } else {
          this.verifyInputRule[fieldName] = false;
        }
      } else {
        this.verifyInputRule[fieldName] = false;
      }
      return this.verifyInputRule[fieldName];
    },
    getScannerBarcodeRegex() {
      let regexList = []
      for (let k in this.verify) {
        regexList.push(this.verify[k].verifyRegex);
      }
      return regexList;
    },
    openScanner() {
      let form = Object.assign({}, this.form);
      for (let k in this.verify) {
        if (this.verify[k].status === false) {
          form[k] = '';
        }
      }

      this.$store.dispatch('sentApp', {
        action: 'openScanner',
        payload: { type: 3, content: form, isAllowInput: true, barcodeRegex: this.getScannerBarcodeRegex() },
      });
    },
    getFormData(taxData) {  
      let d = JSON.parse(taxData);
      for (let i = 0; i <= 2; i++) {
        this.form['barcode' + (i + 1)] = d[i];
        if (d[i]) {
          this.verifyForm(`barcode${i + 1}`);
        }
      }
    },
    validateForm() {
      var allSuccess = true;
      for (let i = 0; i <= 2; i++) {
        allSuccess = allSuccess && this.verifyForm(`barcode${i + 1}`);
      }
      return allSuccess;
    },
    getScanningResult(taxBarcode) {
      this.getFormData(taxBarcode);
      this.openScan = false;
    },
    getPaymentInformation(isScanning) {
      if (!this.validateForm()) {
        return;
      }
      var form = {
        payment_item_id: 'TWNCH-0707',
        payment_query_type: 3,
        parameter1: this.form.barcode1,
        parameter2: this.form.barcode2,
        parameter3: this.form.barcode3,
        payment_custom_id: isScanning ? '' : '',
      };
      queryBillList(form).then((res) => {
        if (res.error === undefined) {
          if (isScanning) {
            this.$router.push({
              path: '/goPay',
              query: {
                payment_item_id: 'TWNCH-0707',
                parameter1: this.form.barcode1,
                parameter2: this.form.barcode2,
                parameter3: this.form.barcode3,
                payment_query_type: 3,
              },
            });
          } else {
            this.$router.push({
              path: '/goPay',
              query: {
                payment_item_id: 'TWNCH-0707',
                parameter1: this.form.barcode1,
                parameter2: this.form.barcode2,
                parameter3: this.form.barcode3,
                payment_query_type: 3,
              },
            });
          }
        } else {
          alert(res.error.message);
        }
      });
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.required {
  margin-top: 2pt;
  margin-bottom: 26pt;
  font-size: 12pt;
}

.hint {
  display: flex;
  flex-flow: row;
  align-items: center;
  margin: 18px auto 0px auto;
  justify-content: center;
}

.hint span {
  color: rgba(64, 64, 64, 0.6);
  font-size: 14px;
  text-align: center;  
  line-height: 24px;
}


.up {
  animation: slideUp 0.3s ease-in-out both;
}

.down {
  animation: slideDown 0.3s ease-in-out both;
}

.item {
  min-height: 56px;
  padding-left: 20px;
  padding-right: 20px;
  background: white;
  
}

.item-title {
  margin: 8px 20px;  
  font-size: 14px;
}

.item .text-gray2 {
  border-bottom-color: rgba(64, 64, 64, 0.1);
  border-bottom-width: 1px;
  border-bottom-style: solid;
  line-height: 55px;
}

.search-bar {
  display: flex;
  flex-direction: row;
  vertical-align: middle;
  position: relative;
  top: 30px;
  height:36px;
  margin: 0px 20px 15px 20px;
  background: rgba(142, 142, 147, 0.12);
  padding: 6px 12px;
  align-items: center;
  justify-content: center;
}
 
.empty {
  color: rgba(64, 64, 64, 0.4);
  font-size: 16px;
  margin: 24px auto;
  text-align: center;
}
 
.search-bar input {
  background: transparent;
  border-style: none;
  height: 36px;
  flex-grow: 1;
}

.bottom-dialog .bottom-dialog-content {
}

@keyframes slideUp {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}
</style>
